module.exports = __webpack_public_path__ + "img/mate-card_bodya.f5053c1.png";